export const ProductRange = {
    path: '/product_ranges',
    name: 'product_ranges',
    component: () => import('@/views/ProductRange/ProductRangePage.vue'),
    children: [
        {
            path: '/product_ranges/add',
            name: 'product_ranges.add',
            component: () => import('@/views/ProductRange/Form/ProductRangeForm.vue'),
            props: {addAction: true},
        },
        {
            path: '/product_ranges/edit/:id',
            name: 'product_ranges.edit',
            component: () => import('@/views/ProductRange/Form/ProductRangeForm.vue'),
            props: {updateAction: true}
        },
        {
            path: '/product_ranges/delete/:id',
            name: 'product_ranges.delete',
            component: () => import('@/views/ProductRange/Form/ProductRangeForm.vue'),
            props: {deleteAction: true}
        },
        {
            path: '/product_ranges/view/:id',
            name: 'product_ranges.view',
            component: () => import('@/views/ProductRange/Form/ProductRangeForm.vue'),
            props: {viewAction: true}
        },
    ]
}